import React, { useState, useEffect } from 'react';
import img1 from '../components/images/mobilesecurity/1.png'
import img2 from '../components/images/mobilesecurity/2.png'
import img3 from '../components/images/mobilesecurity/3.png'
import img4 from '../components/images/mobilesecurity/4.png'
import img5 from '../components/images/mobilesecurity/5.png'
import img6 from '../components/images/mobilesecurity/6.png'
import img7 from '../components/images/mobilesecurity/7.png'
import img8 from '../components/images/mobilesecurity/8.png'
import img9 from '../components/images/mobilesecurity/9.png'

const ProductCatalogMobile = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);

  const categories = [
    { id: 'all', name: 'All Products', icon: 'fas fa-th-large' },
    { id: 'mobile', name: 'Mobile & Tablet', icon: 'fas fa-mobile-alt' },
    { id: 'recoiler', name: 'Recoiler Stands', icon: 'fas fa-link' },
    { id: 'sensor', name: 'Sensor Systems', icon: 'fas fa-wifi' },
    { id: 'accessories', name: 'Accessories', icon: 'fas fa-headphones' },
    { id: 'specialty', name: 'Specialty Items', icon: 'fas fa-tools' }
  ];

  const products = [
    {
      id: 'rs001',
      name: 'RS001 Recoiler Stand',
      category: 'recoiler',
      type: 'Security Stand',
      description: 'Recoiler stand with retractable 3.2mm steel wire',
      features: ['Retractable 3.2mm steel wire', 'Lockdown function both sides', 'Locked charging cable', 'Under table screw mount option'],
      image: img1
    },
    {
      id: 'rs001-t',
      name: 'RS001-T Tablet Stand',
      category: 'recoiler',
      type: 'Tablet Stand',
      description: 'Specialized recoiler stand designed for tablets',
      features: ['Tablet-specific design', 'Adjustable viewing angle', 'Secure mounting', 'Cable management'],
      image: img2
    },
    {
      id: 'ms-vertical-001',
      name: 'MS-Vertical-001',
      category: 'mobile',
      type: 'Vertical Stand',
      description: 'White vertical stand with 100dB alarm, supports tablet, earphone, cellphone',
      features: ['100dB alarm volume', 'Tablet support', 'Earphone compatibility', 'Cellphone mounting', 'White finish (Black customizable)'],
      image: img3
    },
    {
      id: 'ms001',
      name: 'MS001 Flat Stand',
      category: 'mobile',
      type: 'Display Stand',
      description: '38CM height, 2 port connectors, flat stand for wall mount display',
      features: ['38CM height', '2 port connectors', 'Wall mount compatible', 'Locked sensor cable with LED', 'Second port for accessory protection'],
      image: img4
    },
    {
      id: 'mc020-1',
      name: 'MC020-1 Mini Standalone',
      category: 'sensor',
      type: 'Mini System',
      description: 'Mini 2 port standalone security system',
      features: ['2 port configuration', 'Standalone operation', 'Compact design', 'Independent functionality'],
      image: img5
    },
    {
      id: 'mh001',
      name: 'MH001 Headphone Stand',
      category: 'accessories',
      type: 'Headphone Stand',
      description: 'Headphone stand supporting earphone, headset display with charging capability',
      features: ['Earphone support', 'Headset display', 'Charging with micro/USB-C', 'Universal compatibility'],
      image: img6
    },
    {
      id: 'mw001',
      name: 'MW001 Watch Stand',
      category: 'accessories',
      type: 'Watch Stand',
      description: 'Watch stand supporting watch band and body protection',
      features: ['Watch band support', 'Body protection', 'Secure mounting', 'Display optimization'],
      image: img7
    },
    {
      id: 'mc001',
      name: 'MC001 Camera Stand',
      category: 'accessories',
      type: 'Camera Stand',
      description: 'Camera stand holder supporting lens display',
      features: ['Camera support', 'Lens display', 'Secure mounting', 'Professional presentation'],
      image: img8
    },
    {
      id: 'mv001',
      name: 'MV001 Shaver Stand',
      category: 'specialty',
      type: 'Shaver Stand',
      description: '38MM height, 2 port connectors, flat stand for wall mount display',
      features: ['38MM height', '2 port connectors', 'Wall mount compatible', 'Specialized for shavers'],
      image: img9
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-radial from-[#323430] via-[#484c44] to-[#323430] font-poppins">
      {/* Hero Header */}
      <div className="bg-black/20 backdrop-blur-md py-16 text-center text-white">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-2">Product Catalog</h1>
          <p className="text-lg">Comprehensive Security Solutions for Electronic Devices</p>
        </div>
      </div>

      <div className="container mx-auto px-4">
        {/* Products Grid */}
        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 mt-12 pb-12">
          {products.map(product => (
            <div key={product.id} className="mb-3">
              <div className="bg-white rounded-3xl p-8 shadow-[0_15px_35px_rgba(0,0,0,0.1)] transition-all duration-300 hover:-translate-y-3 hover:shadow-[0_25px_50px_rgba(0,0,0,0.15)] h-full">
                <div className="flex items-center justify-center mb-6">
                  <img src={product.image} className="object-contain w-full" alt={product.name} />
                </div>
                
                <h3 className="text-2xl font-bold mb-2 text-[#2d3748]">{product.name}</h3>
                <div className="text-[#718096] text-sm mb-4 uppercase tracking-wide">{product.type}</div>
                
                <p className="text-[#4a5568] mb-6 leading-relaxed">{product.description}</p>
                
                <div>
                  <h6 className="font-semibold mb-3">Key Features:</h6>
                  <ul className="space-y-2">
                    {product.features.slice(0, 4).map((feature, index) => (
                      <li key={index} className="text-[#718096] text-sm relative pl-5 before:content-['✓'] before:absolute before:left-0 before:text-[#48bb78] before:font-bold">
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Font Awesome CDN */}
      <link 
        rel="stylesheet" 
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" 
      />
    </div>
  );
};

export default ProductCatalogMobile;